var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReassign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17L19 14M19 14L16 11M19 14H15C12.2386 14 10 11.7614 10 9C10 6.23858 7.76142 4 5 4H1M16 1L19 4M19 4L16 7M19 4L15 4C13.8744 4 12.8357 4.37194 12 4.99963M1 14H5C6.12561 14 7.16434 13.6277 8 13",
    stroke: "#595959",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassign);
export default __webpack_public_path__ + "static/media/reassign.818c98a2a0c95dab8553ef40391fe50d.svg";
export { ForwardRef as ReactComponent };